module.exports = __webpack_public_path__ + "img/ICONO6.42f049c9.png";